import { render, staticRenderFns } from "./WebsiteNewsEdit.vue?vue&type=template&id=f3d61c4e&scoped=true&"
import script from "./WebsiteNewsEdit.vue?vue&type=script&lang=js&"
export * from "./WebsiteNewsEdit.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteNewsEdit.vue?vue&type=style&index=0&id=f3d61c4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d61c4e",
  null
  
)

export default component.exports